import { Layers, Workflow, Settings2, Globe, Wrench } from 'lucide-react';
import { PK_COLORS } from '../PathkitLogo';

const platforms = [
  {
    name: 'Atlassian',
    tagline: 'Jira Service Management',
    body: 'Full template coverage, project design assistant, and JSM-aware suggestions on every plan.',
    icon: Layers,
  },
  {
    name: 'ServiceNow',
    tagline: 'Now Platform',
    body: 'Service catalog, incident, and request templates included on Starter and above.',
    icon: Workflow,
  },
  {
    name: 'Ivanti',
    tagline: 'Neurons / ITSM',
    body: 'ITSM and request-management templates ready for migration projects.',
    icon: Settings2,
  },
  {
    name: 'Generic',
    tagline: 'Any ticketing system',
    body: 'Platform-neutral templates so you can scope before you commit to a vendor.',
    icon: Globe,
  },
  {
    name: 'Custom',
    tagline: 'Bring your own templates',
    body: 'Define your firm\u2019s own playbook once and reuse it across every client engagement.',
    icon: Wrench,
  },
];

export function MarketingPlatforms() {
  return (
    <section id="platforms" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2
            className="text-3xl md:text-4xl font-semibold tracking-tight"
            style={{ color: PK_COLORS.navy }}
          >
            Built for the service desk platforms your clients run
          </h2>
          <p className="mt-4 text-slate-600">
            Pick the template pack that matches the engagement. Switch platforms per client without
            switching tools.
          </p>
        </div>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {platforms.map((p) => {
            const Icon = p.icon;
            return (
              <li
                key={p.name}
                className="rounded-xl border border-slate-200 bg-white p-5 hover:border-slate-300 transition-colors"
              >
                <span
                  className="inline-flex items-center justify-center w-10 h-10 rounded-lg"
                  style={{ backgroundColor: `${PK_COLORS.teal}1A`, color: PK_COLORS.teal }}
                  aria-hidden
                >
                  <Icon className="w-5 h-5" />
                </span>
                <div className="mt-4 text-base font-semibold" style={{ color: PK_COLORS.navy }}>
                  {p.name}
                </div>
                <div className="text-xs text-slate-500">{p.tagline}</div>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.body}</p>
              </li>
            );
          })}
        </ul>

        <p className="mt-8 text-xs text-slate-500">
          Template availability varies by tier &mdash; see{' '}
          <a href="#pricing" className="underline hover:text-slate-700">
            pricing
          </a>{' '}
          for details.
        </p>
      </div>
    </section>
  );
}
